/** @format */
import { Address, AddressWithId } from '@toucan/client/global/transaction';

type AddressToBeTransformed = (Address | AddressWithId) & {
    line1?: string;
    line2?: string;
};

function createAddress(address: Partial<Address>) {
    const newAddress: Address = {
        ...address,
        addressee: address.addressee || '',
        country: address.country || '',
        county: address.county || '',
        id: address.id,
        line1: address.line1 || '',
        line2: address.line2 || '',
        nickname: address.nickname || '',
        postcode: address.postcode || '',
        state: address.state || '',
        town: address.town || '',
        verified: address.verified || false,
        zipcode: address.zipcode || '',
    };

    if (address.country === 'US') {
        delete newAddress.county;
        delete newAddress.postcode;
    } else {
        delete newAddress.state;
        delete newAddress.zipcode;
    }

    return newAddress;
}

export function transformInboundAddressData(address: any): AddressWithId {
    const newAddress = createAddress({
        ...address,
        line1: address.addressLine1,
        line2: address.addressLine2,
        id: address.addressId,
    }) as AddressWithId;

    if (address.country === 'US') {
        newAddress.state = address.county;
        newAddress.zipcode = address.postcode;
    }

    return newAddress;
}

export function transformOutboundAddressData<T extends AddressToBeTransformed>(
    address: T
): T {
    const { id, line1, line2, ...newAddress } = createAddress(address);

    return {
        ...newAddress,
        addressId: id,
        addressLine1: line1,
        addressLine2: line2,
    } as unknown as T;
}
